import React, { useEffect } from 'react';
import { Container, ErrorBoundary, Skeleton } from 'components';
import { AuthorizationService } from 'domain/services';

const LoginLayout = React.lazy(() => import('./LoginLayout'));

export const LoginPage = ({ logout }: { logout?: boolean }) => {
	useEffect(() => {
		if (logout) {
			AuthorizationService.logout();
		}
	}, []);

	return (
		<React.Suspense fallback={<PageSkeleton />}>
			<ErrorBoundary fallback={<PageError />}>
				<LoginLayout />
			</ErrorBoundary>
		</React.Suspense>
	);
};

const PageSkeleton = () => (
	<Container>
		<div className={'flex min-w-[500px] flex-col gap-4'}>
			<Skeleton.Box className={'w-full'} />
			<Skeleton.Box className={'w-1/2'} />
			<Skeleton.Box className={'w-full'} />
			<Skeleton.Box className={'w-1/2'} />
			<Skeleton.Box className={'w-full'} />
		</div>
	</Container>
);
const PageError = () => <div />;
export default LoginPage;
